import * as React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import { withStyles } from "@material-ui/core";
import PercentageNumber from "../UI/PercentageNumber";
import { sortPortfolioOutput, stableSort } from "../../utilities/sorting";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { AppTheme } from "../../theme";

const chartHead = [
  { id: 0, label: "Manager Selected", maxWidth: false, align: "left" },
  { id: 1, label: "Investment Selected", maxWidth: true, align: "left" },
  { id: 2, label: "Type", maxWidth: false, align: "left" },
  { id: 3, label: "Global<br />Category", maxWidth: false, align: "left" },
  { id: 4, label: "Weight", maxWidth: false, align: "right" },
  { id: 5, label: "Ticker", maxWidth: false, align: "right" },
  { id: 6, label: "Inception<br />Date", maxWidth: false, align: "right" },
  { id: 7, label: "Expenses", maxWidth: false, align: "right" },
];

const styles = (theme) => ({
  tableCell: {
    padding: 2,
    fontSize: 12,
    maxWidth: 65,
    "@media print": {
      fontSize: 11,
    },
    "&.header": {
      maxWidth: 65,
      fontSize: 13,
      wordWrap: "break-word",
      fontWeight: 500,
      lineHeight: 1.6,
      color: theme.palette.primary.main,
      "@media print": {
        fontSize: 11,
      },
      "&.extra": {
        maxWidth: 100,
      },
      "&.firstColumn": {
        width: 200,
        minWidth: 200,
      },
    },
  },
});

class CyPortfolioImplementation extends React.Component {
  returnMainTableBodyRow = (manager, index) => {
    const detail = manager.managerDetail;
    const { classes } = this.props;
    return (
      <TableRow key={index}>
        <TableCell className={classes.tableCell}>{detail.Name}</TableCell>
        <TableCell className={classes.tableCell}>
          {detail.ImplementationName}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {detail.ImplementationType === "Exchange-Traded Fund"
            ? "ETF"
            : detail.ImplementationType}
        </TableCell>
        <TableCell className={classes.tableCell}>
          {detail.GlobalCategory}
        </TableCell>
        <TableCell className={classes.tableCell} align={"right"}>
          <PercentageNumber value={manager.managerWeight} />
        </TableCell>
        <TableCell className={classes.tableCell} align={"right"}>
          {detail.ImplementationTicker || "--"}
        </TableCell>
        <TableCell className={classes.tableCell} align={"right"}>
          {detail.ImplementationInceptionDate}
        </TableCell>
        <TableCell className={classes.tableCell} align={"right"}>
          {
            detail.ImplementationExpenseRatio === "" ||
            !detail.ImplementationExpenseRatio
              ? "--"
              : parseFloat(detail.ImplementationExpenseRatio).toFixed(2) + '%'
          }
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { classes, managerList, sortedPortfolioOrders } = this.props;
    const { orderBy, order } = sortedPortfolioOrders;
    const managerFee = managerList.reduce((accu, manager) => {
      return (
        accu +
        manager.managerWeight *
          Number(manager.managerDetail.ImplementationExpenseRatio || 0)
      );
    }, 0);

    return (
      <React.Fragment>
        <Table className="cy-strategy-implementation" style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              {chartHead.map((head, idx) => {
                return (
                  <TableCell
                    key={head.id}
                    variant="head"
                    align={head.align}
                    className={`${classes.tableCell} header ${
                      head.maxWidth ? "extra" : ""
                    } ${idx === 0 ? "firstColumn" : ""}`}
                  >
                    <span dangerouslySetInnerHTML={{ __html: head.label }} />
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {stableSort(managerList, sortPortfolioOutput(order, orderBy))
              .filter((manager) => manager.managerCode !== "USD Cash")
              .map((manager, index) =>
                this.returnMainTableBodyRow(manager, index)
              )}
            {managerList
              .filter((manager) => manager.managerCode === "USD Cash")
              .map((manager, index) =>
                this.returnMainTableBodyRow(manager, index)
              )}
            <TableRow style={{ background: AppTheme.palette.grey[200] }}>
              <TableCell
                className={classes.tableCell}
                align={"right"}
                colSpan={7}
              >
                <b>Average Weighted Expense</b>
              </TableCell>
              <TableCell className={classes.tableCell} align={"right"}>
                <b>
                  <PercentageNumber
                    value={managerFee}
                    needCalculation={false}
                  />
                </b>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Typography
          className={"disclosure"}
          variant={"caption"}
          paragraph
          style={{ marginTop: 16 }}
        >
          Note: See glossary for definition of "expenses".
        </Typography>
      </React.Fragment>
    );
  }
}

CyPortfolioImplementation.propTypes = {
  classes: PropTypes.object.isRequired,
  managerList: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    sortedPortfolioOrders: state.portfolio.sortedPortfolioOrders,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(CyPortfolioImplementation)
);



// WEBPACK FOOTER //
// ./src/components/Charts/CyPortfolioImplementation.jsx